var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContent',[_c('MyRegistrationC',{attrs:{"get":_vm.get,"post":_vm.post,"eventId":this.eventId,"event":_vm.event.event,"division":_vm.event.skus[0]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }